import gql from 'not-graphql-tag';

export const registerResidentialMutation = gql`
  mutation registerResidential($payload: ResidentialRegistrationRequest!) {
    registerResidential(payload: $payload) {
      success
      uid
    }
  }
`;
export const unregisterMutation = gql`
  mutation unregister {
    unregister {
      success
    }
  }
`;
export const getPersonTypeListQuery = gql`
  query GetPersonTypeList(
    $phoneNumber: PhoneNumberPgeFormat
    $accountNumber: String
  ) {
    getPersonTypeList(
      phoneNumber: $phoneNumber
      accountNumber: $accountNumber
    ) {
      personTypes {
        type
      }
      error
    }
  }
`;
export const validatePersonForRegistrationQuery = gql`
  query ValidatePersonForRegistration(
    $payload: ValidatePersonForRegistrationRequest!
  ) {
    validatePersonForRegistration(payload: $payload) {
      personId
    }
  }
`;
export const updatePersonIdValueDetailsMutation = gql`
  mutation UpdatePersonIdValueDetails(
    $payload: UpdatePersonIdValueDetailsRequest!
  ) {
    updatePersonIdValueDetails(payload: $payload) {
      isSuccess
    }
  }
`;

export const validateCommercialAccount = gql`
  query validateCommercialAccountNumber($accountNumber: String!) {
    validateCommercialAccountNumber(accountNumber: $accountNumber) {
      isValidAccountNumber
      isValidBusinessAccount
      shouldUseBookkeeperRegistration
    }
  }
`;

export const registrationOnlineUserMutation = gql`
  mutation RegisterOnlineUser($payload: RegisterOnlineUserRequest!) {
    registerOnlineUser(payload: $payload) {
      success
      uid
      signinToken
      error
    }
  }
`;
